import request from '@/utils/request'

export function status () {
  return request({
    method: 'get',
    params: {
      do: 'status'
    }
  })
}

export function getCustomerInfo () { //  客服api
  return request({
    method: 'get',
    params: {
      do: 'getCustomerInfo'
    }
  })
}
